import { messaging, getToken } from "../firebase";

let tokenPromise = null;

export const getFcmToken = async (registration, vapidKey) => {
    if (!tokenPromise) {
        tokenPromise = (async () => {
            const maxRetries = 3; // Maximum number of retry attempts
            const retryDelay = 1000; // Delay between retries in milliseconds

            for (let attempt = 1; attempt <= maxRetries; attempt++) {
                try {
                    const token = await getToken(messaging, {
                        vapidKey,
                        serviceWorkerRegistration: registration,
                    });
                    return token; // Return the token if successful
                } catch (error) {
                    if (attempt === maxRetries) {
                        tokenPromise = null; // Reset promise on failure after max retries
                        throw error; // Throw the error after exhausting retries
                    }
                    console.warn(
                        `Attempt ${attempt} to fetch FCM token failed. Retrying in ${retryDelay}ms...`,
                        error
                    );
                    await new Promise((resolve) => setTimeout(resolve, retryDelay)); // Wait before retrying
                }
            }
        })();
    }
    return tokenPromise;
};